import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  Typography,
  Stack,
  Checkbox,
} from "@mui/material";
import { ITableHeader, ITableHeaderColumn } from "../../interfaces/table";

const STATUS_COLUMN_WIDTH = 116;
const SLA_COLUMN_WIDTH = 122;

const ListHeader = ({ columns, fontSize = 14, onCheckAll }: ITableHeader) => (
  <TableHead>
    <TableRow>
      {onCheckAll && (
        <TableCell className="p-l-20" width={32}>
          <Checkbox
            sx={{ width: 2, height: 2 }}
            onChange={(_e, checked) => onCheckAll(checked)}
          />
        </TableCell>
      )}
      {columns.map(({ label, helper }: ITableHeaderColumn, i: number) => (
        // Keep header and body aligned for Status/SLA columns.
        <TableCell
          className={`p-y-20 ${i === 0 && !onCheckAll ? "p-l-20" : ""} ${
            ["Operadores logísticos", "Peso"].includes(label) ? "w-20" : ""
          }`}
          sx={{
            ...(label === "Estado"
              ? {
                width: STATUS_COLUMN_WIDTH,
                minWidth: STATUS_COLUMN_WIDTH,
                maxWidth: STATUS_COLUMN_WIDTH,
                pr: 1,
              }
              : {}),
            ...(label === "Estado del SLA"
              ? {
                width: SLA_COLUMN_WIDTH,
                minWidth: SLA_COLUMN_WIDTH,
                pl: 1,
              }
              : {}),
          }}
          key={label}
        >
          <Stack direction="row" spacing={1}>
            <Typography className="text-bold" fontSize={fontSize}>
              {label}
            </Typography>
            {helper && <Typography fontSize={fontSize}>{helper}</Typography>}
          </Stack>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default ListHeader;
